<template>
  <div class="relative home-content" style="padding-bottom: 60px; background-color: #F2F3F6">
    <!-- 轮播 -->
    <div class="w-full relative" style="height: 280px">
      <div class="mask-content">
        <div class="top-mask" />
        <div class="bottom-mask" />
        <div class="top-search" @click="goJumpSearch">
          <van-icon name="search" size="16" style="margin-right: 5px;" />
          {{ searchText }}
        </div>
      </div>
      <van-swipe key="banner" class="my-swipe" indicator-color="#fff" :autoplay="3000">
        <van-swipe-item v-for="(slide, index) in adList" :key="index">
          <a v-if="slide.advertUrl" :href="slide.advertUrl">
            <van-image width="100%" height="100%" fit="fill" :src="slide.picUrl" />
          </a>
          <van-image v-else width="100%" height="100%" fit="fill" :src="slide.picUrl" />
        </van-swipe-item>
      </van-swipe>
    </div>
    <!-- 停车缴费 payForOthers-->
    <plateno-input v-if="payForOthers === 1 && platBizType !== 2" class="plateno-input" />
    <div
      class="home-main"
      :style="{'margin-top': payForOthers === 1 && platBizType !== 2? '0':'-105px' }"
    >
      <!-- 提示注册登录 -->
      <div v-if="!ifLogin" class="tip-login">
        <div class="bg-white flex flex-row justify-between items-center tip-login-content">
          <p class="login-text">登录/注册后可享受更多服务</p>
          <p class="login-btn" @click="goJumpLogin">登录/注册</p>
        </div>
      </div>
      <!-- 菜单图标 -->
      <div class="px-3 menu-content">
        <div class="flex flex-row flex-wrap">
          <div
            v-for="(item, index) in loopList"
            :key="index"
            class="flex flex-col justify-center items-center mt-3"
            :style="'flex-basis:'+ 100/activeClassNum +'%'"
            @click="goNewPage(item)"
          >
            <img :src="item.icon" alt :style="{'height': activeClassNum== 5 ? '48px' : '60px', 'width':activeClassNum== 5 ? '48px' :'60px'}">
            <p class="mt-2 text-13 text-gray-700">{{ item.name }}</p>
          </div>
        </div>
      </div>
      <!-- 历史欠费 homeParkingCharge-->
      <div v-if="msg && homeParkingCharge === 1 && platBizType !== 2" class="px-3">
        <div class="history-park-charge" @click="goPay">
          <div class="flex flex-row items-center">
            <van-icon name="warning" size="16" color="#FF952C" class="mr-2" />
            <span>{{ msg }}</span>
          </div>
          <van-icon name="arrow" size="18" />
        </div>
      </div>
      <!-- 在停展示 homeParkingCharge 和 充电展示 charging    -->
      <div
        v-if="(homeParkingCharge === 1 && (parkingList.length || noParkingList.length)) || (charging === 1 && orderList.length)"
        style="margin-top:10px;padding: 0 10px;"
      >
        <van-swipe class="parking-swipe" indicator-color="#3880FF" @change="onChange">
          <!-- 在停 -->
          <template v-if="parkingList.length && homeParkingCharge === 1 && platBizType !== 2">
            <van-swipe-item v-for="(item, index) in parkingList" :key="'parkingList' + index">
              <div class="parking-card" @click="goPayDetail(item)">
                <div class="parking-item-title">{{ item.formatPlateNo }}</div>
                <!-- 先在停 -->
                <div v-if="item.parkStartTime && !swipeLoading" class="parking-item-bottom">
                  <p class="parking-item-time">
                    <van-icon name="clock" color="#4182F4" />
                    <span class="ml-1 text-sm text-gray-500">{{ item.parkStartTime }}</span>
                  </p>
                  <div class="text-sm parking-item-desc" style="color: #4182f4">
                    <van-tag
                      v-if="!item.parkFee && item.isBagCar == 0 && item.parkFeeSucc"
                      round
                      type="primary"
                      color="rgba(56,128,255,0.1)"
                      text-color="#3880FF"
                      style="padding: 4px 12px;font-size:14px"
                    >免费时长内</van-tag>
                    <van-tag
                      v-if="!item.parkFee && item.isBagCar == 1"
                      round
                      type="primary"
                      color="rgba(0,165,0,0.1)"
                      text-color="#00A500"
                      style="padding: 4px 12px;font-size:14px"
                    >已停在包期区域</van-tag>
                    <p v-if="item.parkFee && item.parkFeeSucc" class="flex items-center">
                      <span class="text-xs mr-1" style="color: #333;">账单金额:</span>
                      <span
                        class="text-base"
                        style="color: #FF952C;font-weight:500"
                      >{{ (item.parkFee/100).toFixed(2) }}元</span>
                    </p>
                    <p v-if="!item.parkFee && !item.parkFeeSucc" class="flex items-center">
                      <span class="text-xs mr-1" style="color: #333;">账单金额:</span>
                      <span
                        class="text-base"
                        style="color: #FF952C;font-weight:500"
                      >--</span>
                    </p>
                  </div>
                </div>
                <!-- 后查询 -->
                <div
                  v-else-if="swipeLoading"
                  class="parking-item-bottom"
                  style="justify-content: center;"
                >
                  <p class="no-parking-text">查询中</p>
                  <van-loading style="margin-left: 4px;" type="spinner" size="16px" />
                </div>
                <!-- 最后暂无 -->
                <div v-else class="flex items-center justify-center flex-1">
                  <p class="no-parking-text">暂无在停信息</p>
                </div>
              </div>
            </van-swipe-item>
          </template>
          <!-- 在充  和 预约充电 -->
          <template v-if="orderList.length && charging === 1 && platBizType !== 1">
            <van-swipe-item v-for="(item, index) in orderList" :key="'orderList' + index">
              <div class="parking-card" @click="goDetail(item.orderNo)">
                <div
                  class="parking-item-title"
                >{{ item.stationName +'-'+item.deviceName+'-'+item.gunName }}</div>
                <div class="parking-item-bottom">
                  <p class="parking-item-time">
                    <van-icon name="clock" color="#4182F4" />
                    <span
                      class="ml-1  text-gray-500"
                      :style="{ 'font-size': item.orderStateText=='预约中'? '13px': '14px' }"
                    >{{ item.homeStartTime }}</span>
                  </p>
                  <div class="text-sm parking-item-desc" style="color: #4182f4">
                    <van-tag
                      round
                      type="primary"
                      color="#0ECCAF"
                      text-color="#fff"
                      style="padding: 4px 12px;font-size:14px"
                    >{{ item.orderStateText }}</van-tag>
                  </div>
                </div>
              </div>
            </van-swipe-item>
          </template>
          <!-- 暂无 => 变在停 -->
          <template v-if="noParkingList.length && homeParkingCharge === 1 && platBizType !== 2">
            <van-swipe-item v-for="(item, index) in noParkingList" :key="'noParkingList' + index">
              <div class="parking-card" @click="goPayDetail(item)">
                <div class="parking-item-title">{{ item.formatPlateNo }}</div>
                <!-- 先暂无 -->
                <div
                  v-if="!item.parkStartTime && !swipeLoading"
                  class="flex items-center justify-center flex-1"
                >
                  <p class="no-parking-text">暂无在停信息</p>
                </div>
                <!-- 再查询 -->
                <div
                  v-else-if="swipeLoading"
                  class="parking-item-bottom"
                  style="justify-content: center;"
                >
                  <p class="no-parking-text">查询中</p>
                  <van-loading style="margin-left: 4px;" type="spinner" size="16px" />
                </div>
                <!-- 最后在停 -->
                <div v-else class="parking-item-bottom">
                  <p class="parking-item-time">
                    <van-icon name="clock" color="#4182F4" />
                    <span class="ml-1 text-sm text-gray-500">{{ item.parkStartTime }}</span>
                  </p>
                  <div class="text-sm" style="color: #4182f4">
                    <van-tag
                      v-if="!item.parkFee && item.isBagCar == 0"
                      round
                      type="primary"
                      color="rgba(56,128,255,0.1)"
                      text-color="#3880FF"
                      style="padding: 4px 12px;font-size:14px"
                    >免费时长内</van-tag>
                    <van-tag
                      v-if="!item.parkFee && item.isBagCar == 1"
                      round
                      type="primary"
                      color="rgba(0,165,0,0.1)"
                      text-color="#00A500"
                      style="padding: 4px 12px;font-size:14px"
                    >已停在包期区域</van-tag>
                    <p v-if="item.parkFee" class="flex items-center">
                      <span class="text-xs mr-1" style="color: #333;">账单金额:</span>
                      <span
                        class="text-base"
                        style="color: #FF952C;font-weight:500"
                      >{{ (item.parkFee/100).toFixed(2) }}元</span>
                    </p>
                  </div>
                </div>
              </div>
            </van-swipe-item>
          </template>
        </van-swipe>
      </div>

      <!-- 添加车辆信息 登录且车牌个数为0 -->
      <div v-if="showAdd" class="add-car-container">
        <div class="add-car" @click="goAddCar">
          <p class="title">您还未添加车辆信息</p>
          <div class="btn">
            <van-icon name="plus" />
            <span class="text">添加车辆</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 附近停车点 -->
    <div v-if="address" class="park-list">
      <div class="top">
        <div class="left">
          <p class="count">附近找到{{ parkNum || stationNum }}个{{ platBizType === 2? '充电站':'停车点' }}</p>
          <p class="address">
            <van-icon name="location" color="#4182F4" />
            <span>{{ address }}</span>
          </p>
        </div>
        <div class="right" @click="goJumpMap">
          更多
          <img :src="arrowRightImg">
        </div>
      </div>
      <park-list
        v-if="(platBizType === 1 || platBizType === 3) && getedPosition"
        :markers="parkingItems"
        :map-flag="mapFlag"
        @gotoParkDetail="gotoParkDetail"
      />
      <!-- 附近充电站 -->
      <charge-list
        v-if="platBizType === 2 && getedPosition"
        :markers-station="stationItems"
        :map-flag="mapFlag"
        @gotoChargeDetail="gotoParkDetail"
      />
    </div>
    <!-- 资讯 -->
    <news-list v-if="newsFlag === 1" />

    <!-- 选择导航 -->
    <div v-if="goMap" id="androidDialog2" class="js_dialog" style="opacity: 1">
      <div class="weui-mask" />
      <div class="weui-dialog weui-skin_android">
        <div class="weui-dialog__bd">确定对停车点进行导航么？</div>
        <div class="weui-dialog__ft">
          <a
            href="javascript:"
            class="weui-dialog__btn weui-dialog__btn_default"
            @click.stop="cancel"
          >取消</a>
          <a
            href="javascript:"
            class="weui-dialog__btn weui-dialog__btn_primary"
            @click.stop="primary('高德')"
          >高德地图</a>
          <a
            href="javascript:"
            class="weui-dialog__btn weui-dialog__btn_primary"
            @click.stop="primary('百度')"
          >百度地图</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-undef */
import api from '../api/home.js'
import API from '@/api/dynamicRouter.js'
import api_login from '@/api/login.js'
import api_mine from '@/api/mine.js'
import api_map from '@/api/map.js'
import store from '../store/index.js'
import { setJsapiSign, setAMap, setBMap, JumpToMapApp, AliReady } from '../utils/index'
import { clientTYPE } from '../utils/constant.js'
import 'swiper/dist/css/swiper.css'
import _axios from '@/utils/service'
import wx from 'weixin-js-sdk'
import newsList from '@/components/newsList.vue'
import parkList from './map/parkList.vue'
import chargeList from './map/chargeList.vue'
import PlatenoInput from '@/components/platenoInput'
import { getCookie } from '@/utils/index.js'
import weui from 'weui.js'
import { transformFromGCJToBaidu } from '@/utils/WSCoordinate.js'
const img = require('@/assets/hikParkAd.png')

export default {
  name: 'Home',
  components: {
    PlatenoInput,
    newsList,
    parkList,
    chargeList
  },
  filters: {
    changeNum(val) {
      let num
      val > 999 ? (num = `${(val / 1000).toFixed(2)}km`) : (num = `${val}m`)
      return num
    }
  },
  data() {
    return {
      arrowRightImg: require('../assets/indexChange/arrow-right.png'),
      getedPosition: false, // 是否已获取地址位置
      latitude: '',
      longitude: '',
      searchText: '搜索目的地/停车场/充电站',
      address: '',
      errorString: '无更多停车点',
      parkingItems: [], // 附近停车点
      stationItems: [], // 附近充电站
      parkNum: 0, // 附近停车点数量
      stationNum: 0, // 附近充电站数量
      adList: [],
      headerColor: '#098CFF',
      loopList: [],

      activeClassNum: 2,
      driverId: '',
      chargeInfo: {
        time: '2018-09-12 16:01',
        plateNo: '浙A·12345',
        description:
          '星光大道东停车场星光大道东停车场星光大道东停车场星光大道东停车场星光大道东停车场星光大道东停车场星光大道东停车场',
        isFree: true
      },
      newsFlag: 0,
      swiperOption: {
        loop: false,
        pagination: {
          el: '.swiper-pagination'
        },
        autoplay: {
          disableOnInteraction: false, // 用户操作swiper之后，是否禁止autoplay。
          delay: 3000, // 自动切换的时间间隔，单位ms
          reverseDirection: false, // 开启反向自动轮播。
          waitForTransition: true // 等待过渡完毕。自动切换会在slide过渡完毕后才开始计时。
        }
      },
      orderList: [], // 充电的订单
      parkingList: [], // 在停的订单
      noParkingList: [], // 绑定未在停的订单
      swipeLoading: false, // 轮播图的加载状态
      showAdd: false,
      msg: '',
      arrearsItem: null, // 单个欠费信息
      mapFlag: -1, // -1-还没获取到地图类型(按需加载需要) 1-高德 2-百度 3-高德
      goMap: false,
      platBizType: 1,
      payForOthers: 0,
      homeParkingCharge: 0,
      charging: 0,
      ifLogin: getCookie('token'),
      wrongTimePackage: false,
      monthActive: false,
      chargeActive: false,
      wrongTimeSubscribe: false,
      clientType: localStorage.getItem('clientType'),
      mapKey: ''
    }
  },
  async created() {
    // 获取首页菜单配置
    this.getWebPageConfig()
    // 获取应用配置
    this.getParamConfig()
    this.getCardNum()
    await this.getMapType()
    if (this.ifLogin) {
      this.getMsp()
      this.getParkingList()
    }
    api_mine.getMenu().then((resp) => {
      this.newsFlag = resp.data.news
      this.payForOthers = resp.data.payForOthers
      this.homeParkingCharge = resp.data.homeParkingCharge
      this.charging = resp.data.charging
    })
  },
  mounted() {
    const self = this
    const clientType = localStorage.getItem('clientType')

    if (clientType == clientTYPE.WX) {
      setJsapiSign(store).then(() => {
        /* 微信公众号渠道进来，由微信获取地理位置 */
        self.WXgetLocation()
      })
    } else if (clientType == clientTYPE.ALI) {
      // 支付宝生活号渠道，由支付宝获取地理位置
      AliReady(() => {
        AlipayJSBridge.call('getLocation', { requestType: 2 },
          result => {
            if (result.error) {
              self.errorString = '停车点查询失败'
            } else {
              self.showPosition(result)
            }
          })
      })
    } else {
      /* 非微信公众号，等待500ms百度地图组件加载后，根据url中提供的地理位置进行定位 */
      this.getLocation()
    }
  },
  methods: {
    goJumpSearch() {
      this.$router.push({ path: '/searchPage' })
    },
    goJumpLogin() {
      this.$router.push({ path: '/login' })
    },
    goPay() {
      if (this.arrearsItem) {
        this.$router.push({
          path: '/payPage',
          query: {
            uniqueId: this.arrearsItem.uniqueId,
            parkId: this.arrearsItem.parkId
          }
        })
      } else {
        this.$router.push('/multiPayPage?arrearsOnly=1')
      }
    },
    cancel() {
      this.goMap = false
    },
    getMapType() {
      return new Promise(resolve => {
        api_map.getMapType().then((resp) => {
          this.mapFlag = resp.data.type
          this.mapKey = resp.data.bmapAk
          resolve()
        })
      })
    },
    openBMap(item) {
      if (this.mapFlag == 1) {
        this.primary('高德', item)
      } else if (this.mapFlag == 2) {
        this.primary('百度', item)
      } else if (this.mapFlag == 3) {
        this.goMap = true
      }
    },
    primary(val, parkItem) {
      this.goMap = false
      const originPos = {
        lat: localStorage.getItem('lat'),
        lng: localStorage.getItem('lng')
      }
      JumpToMapApp(
        originPos,
        { lat: parkItem.latitude, lng: parkItem.longitude },
        parkItem.parkName,
        val
      )
    },
    goStationDetail(item) {
      this.$router.push({ path: 'chargeStationDetail', query: { stationId: item.stationId }})
    },
    goSearch() {
      this.$router.push({ path: '/search' })
    },
    goStationSearch() {
      this.$router.push('/map?isFromHome=2')
    },
    search() {
      this.$router.push({ path: '/search?type=1' })
    },

    // 获取历史欠费信息
    async getMsp() {
      if (getCookie('token')) {
        const res = await _axios('/charge/v2/api/parkOrders/msp', {
          params: {
            pageNo: 1,
            pageSize: 999,
            requestType: 2
          }
        })

        if (res.data.results && res.data.results.length) {
          if (res.data.results.length === 1) {
            this.arrearsItem = res.data.results[0]
          } else {
            this.arrearsItem = null
          }
          const formatPlateNoArr = res.data.results.map((val) => val.formatPlateNo)
          const tempSetArr = [...new Set(formatPlateNoArr)]
          if (tempSetArr.length == 1) {
            this.msg = `${res.data.results[0].formatPlateNo}有${res.data.results.length}笔欠费，请尽快处理`
          } else {
            this.msg = `您有${res.data.results.length}笔欠费，请尽快处理`
          }
        }
      }
    },

    // 获取在停和未停
    async getParkingList() {
      if (getCookie('token')) {
        const res = await _axios('/charge/v2/api/parkOrders/msp/boundVehicleParkingBills')
        this.parkingList = res.data.results.filter((item) => item.uniqueId)
        this.noParkingList = res.data.results.filter((item) => !item.uniqueId)
      }
    },

    // 获取在充
    async getOrderList() {
      const res = await _axios('/cps/v2/api/chargingOrders/msp', {
        params: {
          requestType: 1,
          pageNo: 1,
          pageSize: 20
        }
      })
      this.orderList = res.data.results
    },

    // 在停轮播
    onChange(index) {
      const _ind = index
      const plateIds = this.parkingList.map(item => item.plateId)
      this.orderList.map(() => { plateIds.push('') })
      this.noParkingList.map(item => { plateIds.push(item.plateId) })
      if (!plateIds[_ind]) {
        if (this.$store.getters.menuCofig.charging === 1 && this.ifLogin) {
          this.getOrderList()
        }
      } else {
        this.swipeLoading = true
        api.getBoundVehicleParkingBill({ plateId: plateIds[_ind] }).then((res) => {
          if (_ind < this.parkingList.length) {
            this.parkingList[_ind].isBagCar = res.data.isBagCar
            this.parkingList[_ind].parkFee = res.data.parkFee
            this.parkingList[_ind].parkStartTime = res.data.parkStartTime
            this.parkingList[_ind].parkFeeSucc = res.data.parkFeeSucc
          } else if (_ind >= (this.parkingList.length + this.orderList.length)) {
            this.noParkingList[_ind - this.parkingList.length - this.orderList.length].isBagCar = res.data.isBagCar
            this.noParkingList[_ind - this.parkingList.length - this.orderList.length].parkFee = res.data.parkFee
            this.noParkingList[_ind - this.parkingList.length - this.orderList.length].parkStartTime = res.data.parkStartTime
          }
        }).finally(() => {
          this.swipeLoading = false
        })
      }
    },

    // 前往停车缴费详情
    goPayDetail(item) {
      if (item.uniqueId && !this.swipeLoading) {
        this.$router.push('/payPage?uniqueId=' + item.uniqueId + '&parkId=' + item.parkId)
      }
    },

    // 前往充电缴费详情
    goDetail(orderNo) {
      this.$router.push(`/chargingResults?orderNo=${orderNo}`)
    },

    // 前往车辆添加
    goAddCar() {
      this.$router.push('/addCar')
    },

    // 获取车牌数量
    async getCardNum() {
      if (getCookie('token')) {
        const res = await _axios('/driver/v2/api/plateCount')
        if (res.data.count == 0) {
          this.showAdd = true
        }
      }
    },

    async getWebPageConfig() {
      const self = this
      await self.getbtnList()
      API.getHomeMenu().then((res) => {
        const arr = []
        res.data.list && res.data.list.forEach((item) => {
          if (item.entryType === 2) { // 第三方h5页面入口
            item.icon = 'data:image/png;base64,' + item.icon
            item.name = item.entryName
            arr.push(item)
          } else if (item.entryId === 'OPEN_WITHHOLD') { // 开通无感 生活号无
            if (localStorage.getItem('clientType') != self.$clientTYPE.ALI) {
              item.icon = 'data:image/png;base64,' + item.icon
              item.name = item.entryName
              arr.push(item)
            }
          } else {
            item.icon = 'data:image/png;base64,' + item.icon
            item.name = item.entryName
            arr.push(item)
          }
        })
        this.loopList = arr
        this.activeClassNum = res.data.column
      })
    },

    // 获取应用配置
    getParamConfig() {
      this.$store.dispatch('commitParamCofig')
    },

    getbtnList() {
      // 获取菜单按钮权限
      return new Promise((resolve) => {
        const self = this
        self.$store.dispatch('commitMenuCofig').then((btnList) => {
          if (btnList.platBizType === 3 && btnList.charging === 1) { // 平台业务类型停车充电业务 判断是否有充电权限
            self.platBizType = 3
          } else if (btnList.platBizType === 3 && btnList.charging !== 1) {
            self.platBizType = 1
          } else {
            self.platBizType = btnList.platBizType
          }
          if (self.platBizType === 3) {
            self.searchText = '搜索目的地/停车场/充电站'
          } else if (self.platBizType === 1) {
            self.searchText = '搜索目的地/停车场'
          } else if (self.platBizType === 2) {
            self.searchText = '搜索目的地/充电站'
          }
          if (self.$store.getters.menuCofig.charging === 1 && this.ifLogin) {
            self.getOrderList()
          }
          resolve()
        })
      })
    },

    // 获取经纬度信息
    getLocation() {
      const self = this
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(self.showPosition, self.showError)
      } else {
        alert('浏览器不支持地理定位。')
      }
    },

    /* 获取经纬度成功后续操作 */
    // 杭州市经纬 lng = 120.216603; lat = 30.208999;
    showPosition(position) {
      let lat = ''
      let lng = ''
      if (position.coords) {
        lat = position.coords.latitude // 纬度
        lng = position.coords.longitude // 经度
      } else {
        lat = position.latitude
        lng = position.longitude
      }
      this.getedPosition = true
      if (self.mapFlag === 2) {
        const marker = transformFromGCJToBaidu(lat, lng)
        lat = marker.latitude
        lng = marker.longitude
      }
      localStorage.setItem('lat', lat)
      localStorage.setItem('lng', lng)
      if (this.platBizType === 1 || this.platBizType === 3) { // 仅停车或停车+充电
        this.getNearByParks(lng.toString(), lat.toString())
      } else if (this.platBizType === 2) { // 仅充电)
        this.getNearbyStations(lng.toString(), lat.toString())
      }
      this.getAd(lng.toString(), lat.toString())
    },

    getAdsList(city) {
      const self = this
      if (!city) {
        city = '全国'
      }
      api
        .getAds({ cityName: city })
        .then((res) => {
          if (res.data.results.length > 0) {
            self.adList.splice(0, self.adList.length)
            res.data.results.forEach((item) => {
              self.adList.push(item)
            })
          } else {
            self.adList.splice(0, self.adList.length)
            self.adList.push({ picUrl: img, bgColor: '#098CFF' })
          }
        })
        .catch(() => {
          self.adList.splice(0, self.adList.length)
          self.adList.push({ picUrl: img })
        })
    },

    // 首页获取附近停车点
    getNearByParks(destLng, destLat) {
      // 杭州市经纬度
      const self = this
      api.getNearByParksHome({ destLng, destLat }).then((res) => {
        if (res.data.results) {
          self.parkNum = res.data.totalRecord
          self.parkingItems = res.data.results
        } else {
          this.parkNum = 0
          this.parkingItems = []
        }
      })
    },

    // 首页获取附近充电站
    getNearbyStations(destLng, destLat) {
      api_map.getNearbyStations({ destLng, destLat, source: 1 }).then((res) => {
        if (res.data.results) {
          this.stationNum = res.data.totalRecord
          this.stationItems = res.data.results.slice(0, 3)
        } else {
          this.stationNum = 0
          this.stationItems = []
        }
      })
    },

    async getAd(lng, lat) {
      if (!this.mapKey) {
        await this.getMapType()
      }
      if (this.mapFlag == 2) {
        this.getBmapAddress(lng, lat)
      } else {
        this.getAmapAddress(lng, lat)
      }
    },
    getBmapAddress(lng, lat) {
      const self = this
      setBMap(this.mapKey).then(() => {
        const BGeocoder = new BMapGL.Geocoder()
        const BPoint = new BMapGL.Point(lng, lat)
        BGeocoder.getLocation(BPoint, (result) => {
          if (result.address) {
            const { city = '', province = '' } = result.addressComponents
            const locationCity = city || province
            // 搜索页和到导航时需要
            localStorage.setItem('locationCity', locationCity)
            self.address = result.address
            self.getAdsList(locationCity)
          }
        })
      })
    },
    getAmapAddress(lng, lat) {
      const self = this
      setAMap(this.mapKey).then(() => {
        var map = new AMap.Map('mapContainer')
        map.plugin('AMap.Geocoder', function() {
          var geocoder = new AMap.Geocoder({
            city: '010'
          })
          var lnglat = [lng, lat]
          geocoder.getAddress(lnglat, function(status, result) {
            if (status === 'complete' && result.info === 'OK') {
              // 保存定位的默认城市
              localStorage.setItem(
                'locationCity',
                result.regeocode.addressComponent.city || result.regeocode.addressComponent.province
              )
              self.getAdsList(result.regeocode.addressComponent.province)
              self.address =
                result.regeocode.addressComponent.province +
                result.regeocode.addressComponent.district +
                result.regeocode.addressComponent.township
            }
          })
        })
      })
    },
    WXgetLocation() {
      const self = this
      wx.getLocation({
        isHighAccuracy: true,
        altitude: 'true',
        type: 'gcj02', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
        success: function(res) {
          self.showPosition(res)
        },
        fail: function() {
          this.errorString = '停车点查询失败'
        }
      })
    },
    goNewPage(item) {
      // if (item.entryId === '停车缴费') {
      //   this.$router.push('/scanPayPage')
      // } else
      if (item.entryId === 'BAG') { // 车场包期
        if (
          this.$store.getters.menuCofig.bagPlan === 1 ||
          this.$store.getters.menuCofig.bagPlan === 3
        ) {
          // 老方案。跳转停车场列表
          this.$router.push('/map?parkType=monthActive')
        } else if (this.$store.getters.menuCofig.bagPlan === 2) {
          // 新方案、跳转规则列表
          this.$router.push('/nearbyBagRules')
        }
      } else if (item.entryId === 'DIFF_TIME') { // 错时共享
        api.checkIntegral().then(res=>{
          if(!res.data.allow){
            weui.confirm("您的信用分低于0分，无法进行错时共享，是否前往查看信用分？", () =>{
              this.$router.push('/integral')
            }, ()=> {
            });
          }else{
            this.$router.push('/wrongTimeShare')
          }
        })
      } else if (item.entryId === 'ACCOUNT_RECHARGE') { // 账户充值 我的钱包
        if (this.$store.getters.menuCofig.walletPlan == 2 && this.$store.getters.menuCofig.supportBalance == 1) {
          this.$router.push('/wallet')
        } else {
          this.$router.push('/accountBalance') // 账户充值
        }
      } else if (item.entryId === 'VEHICLE_BINDING') { // 车辆绑定
        this.$router.push('/carManage')
      } else if (item.entryId === 'OPEN_WITHHOLD') { //  开通无感
        this.$router.push('/sencelessPayment')
      } else if (item.entryId === 'CHARGING_STATION') { // 找充电桩
        this.$router.push('/map?isFromHome=2')
      } else if (item.entryId === 'INVOICE') { // 开具发票
        this.$router.push('/invoiceManage')
      } else if (item.entryId === 'COUPON') { // 优惠券
        this.$router.push('/unused')
      } else if (item.entryId === 'CUSTOMER_SERVICE') { // 客服帮助
        this.$router.push('/customerService/index')
      } else if (item.entryId === 'PARK_COLLECTION') { // 我的收藏
        this.$router.push('/collect')
      } else if (item.entryId === 'BOOK') { // 车场预约
        this.$router.push('/map?parkType=bookActive')
      } else {
        // 获取跳转参数driverId
        if (item.needLogin) {
          api_login.getUserInfo().then((resp) => {
            if (parseInt(resp.code) === 200) {
              this.driverId = resp.data.driverId
            } else {
              this.driverId = ''
            }
            const params = {
              pageId: item.entryId,
              driverId: this.driverId
            }
            API.getWebPageUrl(params).then((res) => {
              if (res && parseInt(res.code) === 200) {
                window.location.href = res.data.url
              }
            })
          })
        } else {
          API.getWebPageUrl({
            pageId: item.entryId,
            driverId: ''
          }).then((res) => {
            if (res && parseInt(res.code) === 200) {
              window.location.href = res.data.url
            }
          })
        }
      }
    },
    updateHeaderColor(val) {
      if (this.adList[val]) {
        this.headerColor = this.adList[val].bgColor
      }
    },
    showError() {
      this.errorString = '停车点查询失败'
    },
    gotoParkDetail(parkId) {
      if (this.platBizType === 2) {
        this.$router.push(`/map?lng=${localStorage.getItem('lng')}&lat=${localStorage.getItem('lat')}&stationId=${parkId}&isDetailCharge=1`)
        return
      }
      this.$router.push(`/map?lng=${localStorage.getItem('lng')}&lat=${localStorage.getItem('lat')}&parkId=${parkId}&isDetailPark=1`)
    },
    goJumpMap() {
      this.$router.push({ path: '/map' })
    }
  }
}
</script>
<style lang="less">
.home-content {
  .van-swipe__indicator {
    background-color: #3880ff;
  }
  .my-swipe {
    .van-swipe__indicators {
      bottom: 120px;
    }
    .van-image {
      margin-top: -20px;
    }
  }
  .parking-swipe {
    .van-swipe__indicators {
      bottom: 0;
      .van-swipe__indicator {
        width: 4px;
        height: 4px;
        background-color: #3880ff;
      }
    }
  }
}
</style>
<style lang="less" scoped>
@import '../assets/css/tailwindcss.less';
.home-main {
  position: relative;
  // margin-top: -105px;
  z-index: 9;
}
.plateno-input {
  z-index: 12;
  margin-top: -105px;
  position: relative;
}
.mask-content {
  // width: 100%;
  // height: 100%;
  // position: absolute;
  // z-index: 5;
  .top-mask {
    width: 100%;
    height: 60px;
    background-image: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0.4) 0%,
      rgba(0, 0, 0, 0) 100%
    );
    position: absolute;
    top: 0;
    left: 0;
    z-index: 5;
  }
  .bottom-mask {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 72px;
    background-image: linear-gradient(
      180deg,
      rgba(239, 240, 244, 0) 0%,
      #eff0f4 65%
    );
    z-index: 6;
  }
  .top-search {
    width: 94%;
    height: 30px;
    background: rgba(255, 255, 255, 0.3);
    color: #ffffff;
    border-radius: 5px;
    display: flex;
    align-items: center;
    padding-left: 8px;
    position: absolute;
    z-index: 6;
    top: 10px;
    left: 3%;
  }
}
// 轮播图
.my-swipe .van-swipe-item {
  height: 280px;
}
.tip-login {
  z-index: 6;
  position: relative;
  padding: 12px 12px 0 12px;
  background: #f2f3f6;
  border-radius: 16px 16px 0px 0px;
  .tip-login-content {
    padding: 10px 12px;
    border-radius: 8px;
    .login-text {
      font-size: 16px;
      color: #666666;
    }
    .login-btn {
      background: #3880ff;
      border-radius: 5px;
      color: #fff;
      font-size: 14px;
      padding: 5px 8px;
    }
  }
}
.menu-content {
  position: relative;
  z-index: 6;
  background: #f2f3f6;
  .text-13 {
    font-size: 13px;
  }
}
// 历史欠费
.history-park-charge {
  background: #fff4e9;
  border: 1px solid rgba(255, 149, 44, 1);
  border-radius: 5px;
  padding: 6px 10px 6px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  line-height: 20px;
  color: #666666;
  font-family: PingFangSC-Regular;
  font-weight: 400;
}

// 在停卡片
.parking-swipe {
  .van-swipe-item {
    height: 90px;
    .parking-card {
      position: relative;
      height: 80px !important;
      box-sizing: border-box;
      background: url('~@/assets/home_parkingCard.png') no-repeat;
      background-size: cover;
      border-radius: 10px;
      padding: 0 5px;
      display: flex;
      flex-direction: column;
      .parking-item-title {
        height: 33px;
        box-sizing: border-box;
        border-bottom: 1px dashed rgba(56, 128, 255, 0.2);
        line-height: 33px;
        padding-left: 11px;
        font-family: PingFangSC-Medium;
        font-size: 16px;
        color: #333333;
        letter-spacing: 0;
        text-align: left;
        font-weight: 500;
        text-overflow: ellipsis;
        overflow: hidden;
        word-break: break-all;
        white-space: nowrap;
      }
      .no-parking-text {
        font-size: 14px;
        color: #666666;
        text-align: center;
      }
      .parking-item-bottom {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 11px;
        box-sizing: border-box;
        // .parking-item-time{
        //   flex:1;
        //   text-overflow: ellipsis;
        //   overflow: hidden;
        //   word-break: break-all;
        //   white-space: nowrap;
        // }
        // .parking-item-desc{
        //   flex-basis: content;
        // }
      }
    }
  }
}

// 车辆添加
.add-car-container {
  margin-top: 10px;
  padding: 0 10px;
  height: 84px;
  box-sizing: border-box;

  .add-car {
    height: 100%;
    padding: 13px 0 13px 20px;
    background: url('../assets/addCarinfo.png') no-repeat;
    background-size: 100% 100%;
    box-sizing: border-box;
    .title {
      font-size: 14px;
      color: rgba(255, 255, 255, 0.8);
      text-shadow: 0 1px 2px rgba(0, 48, 131, 0.3);
      margin-bottom: 7px;
    }
    .btn {
      background: #ffffff;
      border-radius: 2em;
      height: 31px;
      padding: 0 20px;
      line-height: 31px;
      font-size: 14px;
      color: #3880ff;
      width: 120px;
      .text {
        margin-left: 7px;
      }
    }
  }
}
.park-list {
  background: #fff;
  padding: 16px 12px;
  width: calc(100% - 24px);
  margin: auto;
  margin-top: 10px;
  border-radius: 8px;
  .top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 16px;
    border-bottom: 1px solid #efefef;
    .left {
      .count {
        font-family: PingFangSC-Medium;
        font-size: 16px;
        color: #333333;
        font-weight: 500;
        margin-bottom: 2px;
        margin-left: 4px;
      }
      .address {
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.4);
        font-weight: 400;
        margin-left: 2px;
      }
    }
    .right {
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: rgba(51, 51, 51, 0.7);
      font-weight: 400;
      display: flex;
      align-items: center;
      img {
        width: 8px;
        height: 13px;
        margin: 0 4px;
      }
    }
  }
}
</style>
